<template>
  <v-card outlined class="grey lighten-5">
    <v-card-title>กำหนดเงื่อนไขเพิ่มเติม</v-card-title>
    <v-card-text>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="subject_rule_type_id"
              v-bind:label="$t('config_teach_table.subject_rule_type')"
              v-bind:items="subject_rule_types_filtered"
              v-bind:item-value="
                (item) => String(item.TEACH_TABLE_SUBJECT_RULE_TYPE_ID)
              "
              v-bind:item-text="
                (item) =>
                  objectTranslator(item, 'TEACH_TABLE_SUBJECT_RULE_TYPE_NAME')
              "
              clearable
              :rules="subject_rule_type_id ? [requiredRule] : []"
              hide-details="auto"
              outlined
              dense
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
            v-if="
              subject_rule_type_id === '3' ||
                (isGraduate && subject_rule_type_id === '1')
            "
          >
            <v-text-field
              outlined
              dense
              small
              label="ตั้งแต่รหัส"
              v-model="input_from_student_id"
              :maxlength="isGraduate && subject_rule_type_id === '1' ? 8 : undefined"
              :counter="isGraduate && subject_rule_type_id === '1' ? 8 : undefined"
              :rules="studentIdRangeRules"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="
              subject_rule_type_id === '3' ||
                (isGraduate && subject_rule_type_id === '1')
            "
          >
            <v-text-field
              outlined
              dense
              small
              label="ถึงรหัส"
              v-model="input_to_student_id"
              :maxlength="isGraduate && subject_rule_type_id === '1' ? 8 : undefined"
              :counter="isGraduate && subject_rule_type_id === '1' ? 8 : undefined"
              :rules="studentIdRangeRules"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="subject_rule_type_id === '4'">
            <v-autocomplete
              v-model="rule_registrar_faculty_id"
              :rules="[requiredRule]"
              v-bind:label="$t('config_teach_table.faculty')"
              v-bind:items="registrar_faculties"
              v-bind:item-value="(item) => item.faculty_id"
              v-bind:item-text="
                (item) =>
                  inlineTranslator({
                    en: item.faculty_name_en,
                    th: item.faculty_name_th,
                  })
              "
              clearable
              outlined
              dense
              @change="(e) => update_faculty_rule(levelId, e)"
            ></v-autocomplete>
            <v-autocomplete
              v-model="rule_registrar_curriculum_id"
              :rules="[requiredRule]"
              :disabled="!rule_registrar_faculty_id"
              v-bind:label="$t('config_teach_table.curriculum')"
              v-bind:items="
                listFilter(
                  registrar_curriculums,
                  rule_registrar_faculty_id,
                  'faculty_id'
                )
              "
              v-bind:item-value="(item) => item.curriculum_id"
              v-bind:item-text="
                (item) =>
                  inlineTranslator({
                    en: item.curriculum_name_en,
                    th: item.curriculum_name_th,
                  })
              "
              outlined
              dense
            ></v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            md="6"
            v-if="isGraduate && subject_rule_type_id === '2'"
          >
            <v-autocomplete
              v-model="rule_study_plan"
              :rules="[requiredRule]"
              :label="$t('home.study_plan')"
              :items="study_plans"
              item-value="STUDY_PLAN_ID"
              :item-text="study_plan_name"
              return-object
              clearable
              outlined
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" v-if="subject_rule_type_id === '5'">
            <v-autocomplete
              v-model="rule_registrar_faculty_id1"
              :rules="[requiredRule]"
              v-bind:label="$t('config_teach_table.faculty')"
              v-bind:items="registrar_faculties"
              v-bind:item-value="(item) => item.faculty_id"
              v-bind:item-text="
                (item) =>
                  inlineTranslator({
                    en: item.faculty_name_en,
                    th: item.faculty_name_th,
                  })
              "
              clearable
              outlined
              dense
            ></v-autocomplete>
          </v-col>
          <!-- หากมีมากกว่า 1 รหัสนศ. ให้คั่นด้วย ,(comma) หรือ ;(semicolon) ระหว่างรหัสนศ.เท่านั้น เช่น 63xxxxxx,63xxxxxx -->
          <v-col cols="12" md="12" v-if="subject_rule_type_id === '6'">
            <v-textarea
              v-model="input_student_id"
              :rules="[requiredRule, studentIdListRule]"
              label="รหัสนักศึกษา"
              hint="แต่ละรหัสนักศึกษาให้เว้นช่องว่าง 1 ตัวอักษร"
              persistent-hint
              clearable
              outlined
              dense
            ></v-textarea>
          </v-col>
        </v-row>
        <div class="mt-3">
          <v-btn small class="primary white--text" @click="validate()"
            >เพิ่มเงื่อนไข</v-btn
          >
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { objectTranslator, inlineTranslator } from "@/helper/translator";
import RefProvider from "@/services/ref.provider";
import { listFilter } from "@/helper/filter";
const refService = new RefProvider();
import genericProvider from "@/services/generic.provider.js";
const genericService = new genericProvider();

export default {
  name: "RuleSlotAdding",
  components: {},
  data: () => ({
    order: null,
    subject_rule_type_id: null,
    input_student_id: null,
    input_from_student_id: null,
    input_to_student_id: null,
    rule_registrar_faculty_id: null,
    rule_registrar_curriculum_id: null,
    rule_registrar_faculty_id1: null,
    rule_study_plan: null,
    subject_rule_types: [],
    study_plans: [],
    registrar_faculties: [],
    registrar_curriculums: [],
    subject_rule_type_detail: null,
    con1: null,
    con2: null,
    con1_detail: null,
    con2_detail: null,
  }),
  computed: {
    studentIdRangeRules() {
      return this.graduateStudentIdRules.length
        ? this.graduateStudentIdRules
        : [
            this.requiredRule,
            (value) => /^\d{8}$/.test(String(value || "")) ||
              "กรุณากรอกรหัสนักศึกษาเป็นตัวเลข 8 หลัก",
          ];
    },
    isGraduate() {
      return Number(this.levelId) > 1;
    },
    graduateStudentIdRules() {
      if (!this.isGraduate || this.subject_rule_type_id !== "1") return [];
      return [
        (value) =>
          /^\d{1,8}$/.test(String(value || "")) ||
          this.inlineTranslator({
            th: "กรุณากรอกรหัสนักศึกษาเป็นตัวเลขไม่เกิน 8 หลัก",
            en: "Student ID must contain no more than 8 digits",
          }),
      ];
    },
    subject_rule_types_filtered() {
      if (this.isGraduate) {
        return [
          {
            TEACH_TABLE_SUBJECT_RULE_TYPE_ID: "1",
            TEACH_TABLE_SUBJECT_RULE_TYPE_NAME_TH:
              "เฉพาะช่วงรหัสที่กำหนดเท่านั้น(ไม่รับนศ.อื่น)",
            TEACH_TABLE_SUBJECT_RULE_TYPE_NAME_EN:
              "Only students in the specified ID range",
          },
          {
            TEACH_TABLE_SUBJECT_RULE_TYPE_ID: "2",
            TEACH_TABLE_SUBJECT_RULE_TYPE_NAME_TH:
              "เฉพาะแผนการศึกษาที่กำหนดเท่านั้น(ไม่รับนศ.อื่น)",
            TEACH_TABLE_SUBJECT_RULE_TYPE_NAME_EN:
              "Only students in the specified study plan",
          },
        ];
      }
      return this.subject_rule_types.filter((item) => {
        const ruleTypeId = String(
          item.TEACH_TABLE_SUBJECT_RULE_TYPE_ID
        );
        return ruleTypeId !== "1";
      });
    },
  },
  props: {
    levelId: {
      type: [String, Number],
      default: 1,
    },
    current_rule_slots: {
      type: Array,
    },
    add_new_rule_slot: {
      type: Function,
    },
  },
  methods: {
    requiredRule(value) {
      return (value !== null && value !== undefined && String(value).trim() !== "") ||
        "กรุณาระบุข้อมูล";
    },
    studentIdListRule(value) {
      const ids = String(value || "").trim().split(/[\s,;]+/);
      return ids.every((id) => /^\d{8}$/.test(id)) || "กรุณากรอกรหัสนักศึกษาเป็นตัวเลข 8 หลักทุกรหัส";
    },
    objectTranslator,
    inlineTranslator,
    listFilter,
    study_plan_name(item) {
      const levelSuffix =
        Number(item.LEVEL_ID) === 2
          ? { th: " (ป.โท)", en: " (Master's degree)" }
          : Number(item.LEVEL_ID) === 3
          ? { th: " (ป.เอก)", en: " (Doctoral degree)" }
          : { th: "", en: "" };
      return this.inlineTranslator({
        th:
          (item.STUDY_PLAN_NAME_TH || item.STUDY_PLAN_NAME_EN) +
          levelSuffix.th,
        en:
          (item.STUDY_PLAN_NAME_EN || item.STUDY_PLAN_NAME_TH) +
          levelSuffix.en,
      });
    },
    show_backend_error(error) {
      const data = error && error.response && error.response.data;
      const message =
        data && data.message
          ? data.message
          : error && error.message
          ? error.message
          : this.$t("config_teach_table.save_unsuccessfully");
      this.$toasted.error(
        typeof message === "string" ? message : JSON.stringify(message),
        { duration: 0 }
      );
    },

    //===========================================================
    validate() {
      if (this.$refs.form.validate()) {
        this.check_rule_integrity().catch((error) => {
          this.show_backend_error(error);
        });
      }
    },

    //===========================================================
    async update_faculty_rule(level_id, rule_registrar_faculty_id) {
      this.rule_registrar_curriculum_id = null;
      this.registrar_curriculums = [];
      if (!rule_registrar_faculty_id) return;
      try {
        const curriculums = await genericService.getRegistrarCurriculum(
          level_id,
          rule_registrar_faculty_id
        );
        this.registrar_curriculums = curriculums;
      } catch (error) {
        this.show_backend_error(error);
      }
    },
    //===========================================================
    async fetch_data() {
      if (this.rule_registrar_faculty_id && this.registrar_curriculums.length === 0) {
        const curriculums = await genericService.getRegistrarCurriculum(
          this.levelId,
          this.rule_registrar_faculty_id
        );
        this.registrar_curriculums = curriculums;
      }
    },
    async init_data() {
      // const subject_types = await refService.getTeachTableSubjectType();
      // this.subject_types = subject_types;
      // const subject_owners = await refService.getTeachTableSubjectOwner();
      // this.subject_owners = subject_owners;

      if (!this.isGraduate && this.subject_rule_types.length === 0) {
        const subject_rule_types = await refService.getSubjectRuleType();
        this.subject_rule_types = subject_rule_types;
      }

      if (this.isGraduate && this.study_plans.length === 0) {
        const studyPlans = await refService.getStudyPlan();
        const uniqueStudyPlans = new Map();
        (studyPlans || []).forEach((item) => {
          if (Number(item.LEVEL_ID) <= 1) return;
          const programId =
            item.REGISTRAR_PROGRAM_ID === null ||
            item.REGISTRAR_PROGRAM_ID === undefined
              ? ""
              : String(item.REGISTRAR_PROGRAM_ID).trim();
          const subProgramId =
            item.REGISTRAR_SUB_PROGRAM_ID === null ||
            item.REGISTRAR_SUB_PROGRAM_ID === undefined
              ? ""
              : String(item.REGISTRAR_SUB_PROGRAM_ID).trim();
          if (programId === "" || subProgramId === "") return;
          const key = `${programId}|${subProgramId}`;
          if (!uniqueStudyPlans.has(key)) uniqueStudyPlans.set(key, item);
        });
        this.study_plans = [...uniqueStudyPlans.values()];
      }

      if (!this.isGraduate && this.registrar_faculties.length === 0) {
        const faculties = await genericService.getRegistrarFaculty();
        this.registrar_faculties = faculties;
      }

      if (!this.isGraduate) await this.fetch_data();
    },

    async check_rule_integrity(pre_param) {
      let subject_rule_type_id;
      if (this.subject_rule_type_id) {
        subject_rule_type_id = this.subject_rule_type_id;
      }
      let con1 = null;
      let con2 = null;
      if (pre_param) {
        subject_rule_type_id = pre_param.subject_rule_type_id;
        con1 = pre_param.con1;
        con2 = pre_param.con2;
      }
      await this.init_data();
      // let all_rule_slot = this.current_rule_slots;
      subject_rule_type_id = String(subject_rule_type_id);
      if (!pre_param) {
        const fail = (message) => {
          this.$toasted.error(message, { duration: 5000 });
          return false;
        };
        if (!this.subject_rule_types_filtered.some(
          (item) => String(item.TEACH_TABLE_SUBJECT_RULE_TYPE_ID) === subject_rule_type_id
        )) {
          return fail("กรุณาเลือกเงื่อนไข");
        }
        if (["1", "3"].includes(subject_rule_type_id)) {
          const pattern = this.isGraduate ? /^\d{1,8}$/ : /^\d{8}$/;
          if (
            !pattern.test(String(this.input_from_student_id || "")) ||
            !pattern.test(String(this.input_to_student_id || "")) ||
            Number(this.input_from_student_id) > Number(this.input_to_student_id)
          ) {
            return fail("กรุณาระบุช่วงรหัสนักศึกษาให้ถูกต้อง โดยรหัสเริ่มต้นต้องไม่มากกว่ารหัสสิ้นสุด");
          }
        }
        if (["4", "5"].includes(subject_rule_type_id)) {
          const facultyId = subject_rule_type_id === "4"
            ? this.rule_registrar_faculty_id : this.rule_registrar_faculty_id1;
          if (!this.registrar_faculties.some((item) => String(item.faculty_id) === String(facultyId))) {
            return fail("กรุณาเลือกคณะ");
          }
          if (subject_rule_type_id === "4" && !this.registrar_curriculums.some(
            (item) => String(item.faculty_id) === String(facultyId) &&
              String(item.curriculum_id) === String(this.rule_registrar_curriculum_id) &&
              String(item.level_id) === String(this.levelId)
          )) {
            return fail("กรุณาเลือกสาขาวิชาของคณะที่ระบุ");
          }
        }
        if (subject_rule_type_id === "6" && this.studentIdListRule(this.input_student_id) !== true) {
          return fail("กรุณากรอกรหัสนักศึกษาเป็นตัวเลข 8 หลักทุกรหัส");
        }
      }
      this.con1 = null;
      this.con2 = null;
      this.con1_detail = null;
      this.con2_detail = null;
      const subject_rule = subject_rule_type_id;
      const ref_data_rule = this.subject_rule_types_filtered.find(
        (item) => String(item.TEACH_TABLE_SUBJECT_RULE_TYPE_ID) === subject_rule
      );
      this.subject_rule_type_detail = ref_data_rule
        ? this.objectTranslator(
            ref_data_rule,
            "TEACH_TABLE_SUBJECT_RULE_TYPE_NAME"
          )
        : "";
      if (subject_rule_type_id == 3 || subject_rule_type_id == 1) {
        this.con1 = con1 ? con1 : this.input_from_student_id;
        this.con2 = con2 ? con2 : this.input_to_student_id;
        this.con1_detail = null;
        this.con2_detail = null;
      }
      if (this.isGraduate && subject_rule_type_id == 2) {
        const selectedStudyPlan = pre_param
          ? this.study_plans.find(
              (item) =>
                String(item.REGISTRAR_PROGRAM_ID) === String(con1) &&
                String(item.REGISTRAR_SUB_PROGRAM_ID) === String(con2)
            )
          : this.rule_study_plan;
        if (!pre_param && !selectedStudyPlan) {
          this.$toasted.error("กรุณาเลือกแผนการศึกษา", { duration: 0 });
          return false;
        }
        this.con1 = pre_param
          ? String(con1)
          : String(selectedStudyPlan.REGISTRAR_PROGRAM_ID);
        this.con2 = pre_param
          ? String(con2)
          : String(selectedStudyPlan.REGISTRAR_SUB_PROGRAM_ID);
        this.con1_detail = selectedStudyPlan
          ? this.study_plan_name(selectedStudyPlan)
          : `${this.con1}/${this.con2}`;
        this.con2_detail = null;
      }
      if (subject_rule_type_id == 4) {
        this.con1 = con1 ? con1 : this.rule_registrar_faculty_id;
        this.con2 = con2 ? con2 : this.rule_registrar_curriculum_id;

        if (con1) {
          await this.update_faculty_rule(this.levelId, con1);
        }
        // map id to show faculty_name_th
        const registrar_faculty = con1 ? con1 : this.rule_registrar_faculty_id;
        const ref_data = this.registrar_faculties.find(
          (item) => String(item.faculty_id) === String(registrar_faculty)
        );

        this.con1_detail = ref_data ? ref_data.faculty_name_th : this.con1 || "-";
        // map id to show curriculum_name_th
        const level_id = this.levelId;
        const registrar_curriculum_id = con2
          ? con2
          : this.rule_registrar_curriculum_id;

        const data5 = this.registrar_curriculums.find(
          (item) => String(item.level_id) === String(level_id) &&
            String(item.faculty_id) === String(registrar_faculty) &&
            String(item.curriculum_id) === String(registrar_curriculum_id)
        );

        this.con2_detail = data5 ? data5.curriculum_name_th : this.con2 || "-";
      }
      if (subject_rule_type_id == 5) {
        this.con1 = con1 ? con1 : this.rule_registrar_faculty_id1;
        this.con2 = null;
        // map id to show faculty_name_th
        const rule_registrar_faculty_id1 = this.con1;
        const ref_data = this.registrar_faculties.find(
          (item) => String(item.faculty_id) === String(rule_registrar_faculty_id1)
        );
        this.con1_detail = ref_data ? ref_data.faculty_name_th : this.con1 || "-";

        this.con2_detail = null;
      }
      if (subject_rule_type_id == 6) {
        this.con1 = con1 ? con1 : this.input_student_id;
        this.con2 = null;
        this.con1_detail = null;
        this.con2_detail = null;
      }

      // To generate rule object
      if (subject_rule_type_id == 6) {
        const studentIds = String(this.con1 || "").trim().split(/[\s,;]+/);
        if (!studentIds.every((item) => /^\d{8}$/.test(item))) {
          this.$toasted.error("กรุณากรอกรหัสนักศึกษาเป็นตัวเลข 8 หลักทุกรหัส", { duration: 5000 });
          return false;
        }
        const slots = studentIds.map((item) => ({
          subject_rule_type_id: subject_rule_type_id,
          subject_rule_type_detail: this.subject_rule_type_detail,
          start_rule: item,
          end_rule: this.con2,
          start_rule_detail: this.con1_detail,
          end_rule_detail: this.con2_detail,
        }));
        this.add_new_rule_slot(slots);
      } else {
        const ret_rule_slot = {
          subject_rule_type_id: subject_rule_type_id,
          subject_rule_type_detail: this.subject_rule_type_detail,
          start_rule: this.con1,
          end_rule: this.con2,
          start_rule_detail: this.con1_detail,
          end_rule_detail: this.con2_detail,
        };
        this.add_new_rule_slot([ret_rule_slot]);
      }
      //-----------------------------
      this.$refs.form.reset();
      return true;
    },
  },
  async mounted() {
    try {
      await this.init_data();
    } catch (error) {
      this.show_backend_error(error);
    }
  },
  created() {},
};
</script>
